import React from 'react';
import styles from './styles/styles.module.scss';
import { wrapEventHandler } from '../../../utils/handlers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

const { findRecordFieldWithLocale } = LanguageSupportUtil;

const getDisplayName = (trail, forceCityLink, context) => {
  let displayName;
  const localizedAreaName = findRecordFieldWithLocale(trail, 'area_name', context.languageRegionCode);
  if (localizedAreaName && !forceCityLink) {
    displayName = localizedAreaName;
  } else if (trail.park_name && !forceCityLink) {
    displayName = trail.park_name;
  } else if (trail.city_name) {
    displayName = findRecordFieldWithLocale(trail, 'city_name', context.languageRegionCode);
    if (trail.state_name != '' && trail.state_name != null) {
      displayName += (displayName == '' ? '' : ', ') + findRecordFieldWithLocale(trail, 'state_name', context.languageRegionCode);
    }
    if (trail.country_name != '' && trail.country_name != null && trail.country_id != 313 && trail.country_id != 139) {
      displayName += (displayName == '' ? '' : ', ') + findRecordFieldWithLocale(trail, 'country_name', context.languageRegionCode);
    }
  }
  return displayName;
};

const getLocationUrl = (trail, forceCityLink, languageRegionCode) => {
  let innerUrl;
  if (trail.park_slug && !forceCityLink) {
    innerUrl = `/parks/${trail.park_slug}`;
  } else if (trail.area_slug && !forceCityLink) {
    innerUrl = `/${trail.area_slug}`;
  } else if (trail.city_url) {
    innerUrl = `/${trail.city_url}`;
  } else {
    return null;
  }
  if (innerUrl.indexOf('?') < 0) {
    innerUrl = `${innerUrl}?ref=result-card`;
  }
  return LanguageSupportUtil.wrapUrlSafe(innerUrl, languageRegionCode);
};

const wrapLocationClick = (trail, handleClick, forceCityLink) => {
  return e => {
    e.preventDefault();
    e.stopPropagation();
    let locationString = '';
    let locationType = '';
    if (trail.park_slug && !forceCityLink) {
      locationString = trail.park_slug;
      locationType = 'area';
    } else if (trail.area_slug && !forceCityLink) {
      locationString = trail.area_slug.replace(/^parks\//, '');
      locationType = 'area';
    } else if (trail.city_url) {
      locationString = trail.city_url;
      locationType = 'city';
    } else if (trail.area_id) {
      locationString = trail.area_id;
      locationType = 'area_id';
    } else if (trail.city_id) {
      locationString = trail.city_id;
      locationType = 'city_id';
    } else if (trail.state_id) {
      locationString = trail.state_id;
      locationType = 'state_id';
    }
    handleClick(locationString, locationType);
    return false;
  };
};

export default function CardLocation({ trail, forceCityLink, handleClick, className, paddingRight, context }) {
  const displayName = getDisplayName(trail, forceCityLink, context);
  if (!displayName) {
    return null;
  }

  const locationUrl = getLocationUrl(trail, forceCityLink, context ? context.languageRegionCode : null);

  // Overrides the default click behavior of the link
  let onClick;
  if (handleClick) {
    onClick = wrapLocationClick(trail, handleClick, forceCityLink);
  } else if (locationUrl) {
    onClick = wrapEventHandler(() => {
      window.open(locationUrl, '_blank');
    });
  }

  return (
    <a
      className={`xlate-none ${styles.location} ${className}`}
      href={locationUrl}
      onClick={onClick}
      style={{ paddingRight: paddingRight || 0 }}
      title={displayName}
    >
      {displayName}
    </a>
  );
}
